const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
export default API_ENDPOINT;
